<template>
  <CommunicationBubble
    v-if="linkingPath"
    :corresponding-remark-id="id"
    :emit-click="emitClick"
    :linking-path="linkingPath"
    :ordinal="ordinal[linkingPath]"
    :variant="effectiveVariant"
    type="sidepanel"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import useBubbleRegistration from '@app/application/communication/composables/use-bubble-registration'
import CommunicationBubble from '@app/application/communication/sections/communication/components/communication-bubble.vue'

import { useBubbleStore } from '@app/application/communication/store/bubbles'

interface Props {
  emitClick?: boolean
  id: string
  linkingPath: string | null
  preventBubbleUnlink?: boolean
  variant?: 'default' | 'unlinked'
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    click: [Event]
  }>()

const bubbleStore = useBubbleStore()

const { inputBubblesPerPath, ordinal } = storeToRefs(bubbleStore)

useBubbleRegistration({
  type: 'remark',
  path: () => props.linkingPath,
  id: () => props.id,
  preventUnlink: () => props.preventBubbleUnlink,
})

function handleClick(event: Event): void {
  emit('click', event)
}

// Check if a corresponding input bubble exists
const effectiveVariant = computed(() => {
  if (props.variant) {
    return props.variant
  }

  return props.linkingPath && inputBubblesPerPath.value[props.linkingPath]
    ? 'default'
    : 'unlinked'
})
</script>
